import * as Yup from 'yup';

export const initialValuesInsurancePolicyForm = {
    providerName: '',
    policyNumber: '',
    groupNumber: '',
    policyHolderName: '',
    contactPhone: '',
    contactEmail: '',
    contactAddress: '',
    contactCity: '',
    contactProvince: '',
    contactPostal: '',
    contactCountry: '',
    applyToAllFamilyMembers: false,
    status: 'active',
    notes: ''
};

export const insurancePolicyValidationSchema = Yup.object().shape({
    providerName: Yup.string().required('Provider name is required'),
    policyNumber: Yup.string().required('Policy number is required'),
});
